<template>
  <div class="py-10 px-16">
    <p class="font-bold text-xl mb-10">Manage quests</p>
    <p class="text-lg mb-3">Challenges</p>
    <div class="flex flex-wrap gap-2 mb-5">
      <div
        v-for="challenge in challenges"
        :key="challenge.id"
        class="flex-none w-64 relative border border-gray-600 bg-gray-100 rounded-lg p-3 overflow-hidden"
      >
        <p class="font-bold text-sm">{{ challenge.type }}</p>
        <div class="flex italic items-center gap-2">
          <div v-if="challenge.type == 'vcAuth'">
            <p class="text-xs">{{ challenge.data.vcKey }}</p>
          </div>
          <div v-if="challenge.type == 'xPost'">
            <p class="text-xs">{{ challenge.data.message }}</p>
          </div>
          <div v-if="challenge.type == 'xFollow'">
            <p class="text-xs">{{ challenge.data.targetAccount }}</p>
          </div>
          <div v-if="challenge.type == 'xRepost'">
            <p class="text-xs">{{ challenge.data.tweetId }}</p>
          </div>
          <div v-if="challenge.type == 'discordJoin'">
            <p class="text-xs">{{ challenge.data.inviteLink }}</p>
          </div>
          <div v-if="challenge.type == 'facebookFollow'">
            <p class="text-xs">{{ challenge.data.pageId }}</p>
          </div>
          <div v-if="challenge.type == 'facebookPost'">
            <p class="text-xs">{{ challenge.data.message }}</p>
          </div>
          <div v-if="challenge.type == 'ownsBadges'">
            <p v-if="challenge.data.templateHashList" class="text-xxs">
              {{
                challenge.data.templateHashList
                  .map((hash) => hash.slice(0, 6) + '...' + hash.slice(-4))
                  .join(', ')
              }}
            </p>
            <p v-else class="text-xs">No badges</p>
            <p class="text-xs">(count : {{ challenge.data.count }})</p>
          </div>
          <div v-if="challenge.type == 'sentBadges'">
            <p v-if="challenge.data.templateHashList" class="text-xxs">
              {{
                challenge.data.templateHashList
                  .map((hash) => hash.slice(0, 6) + '...' + hash.slice(-4))
                  .join(', ')
              }}
            </p>
          </div>
          <div v-if="challenge.type == 'telegramJoin'">
            <p class="text-xs">{{ challenge.data.targetAccount }}</p>
          </div>
        </div>
        <p class="text-xs">
          Reward : {{ challenge.reward > 0 ? challenge.reward : '-' }}
        </p>
        <p class="text-xs">
          {{
            challenge.created.replace('T', ' ').replace('Z', '').split('.')[0]
          }}
        </p>
        <p
          @click="copyToClipboard(challenge.id)"
          class="text-xxs cursor-pointer"
        >
          {{ challenge.id }}<icon name="copy" class="ml-1" />
        </p>
        <button
          @click="deleteChallenge(challenge.id)"
          class="absolute top-0 right-0 p-3 cursor-pointer"
        >
          <icon name="trash" class="text-xs" />
        </button>
      </div>
    </div>
    <div class="flex gap-2">
      <select
        class="w-[18rem] border-gray-200 border-[1px] focus:border-gray-300 focus:ring-0 placeholder:text-gray-900 placeholder:text-sm hover:bg-gray-light cursor-pointer rounded-md py-1 px-2 mb-1.5 mr-5"
        v-model="challengeType"
      >
        <option value="vcAuth">VC Auth</option>
        <option value="xAuth">X Auth</option>
        <option value="xPost">X Post</option>
        <option value="xFollow">X Follow</option>
        <option value="xRepost">X Repost</option>
        <option value="discordAuth">Discord Auth</option>
        <option value="discordJoin">Discord Join</option>
        <option value="facebookAuth">Facebook Auth</option>
        <option value="facebookFollow">Facebook Follow</option>
        <option value="facebookPost">Facebook Post</option>
        <option value="linkedinAuth">Linkedin Auth</option>
        <option value="telegramAuth">Telegram Auth</option>
        <option value="telegramJoin">Telegram Join</option>
        <option value="ownsBadges">Owns Badges</option>
        <option value="sentBadges">Sent Badges</option>
      </select>
      <div v-if="challengeType == 'vcAuth'" class="flex gap-2">
        <p class="pt-1">VC key :</p>
        <select
          class="w-[18rem] border-gray-200 border-[1px] focus:border-gray-300 focus:ring-0 placeholder:text-gray-900 placeholder:text-sm hover:bg-gray-light cursor-pointer rounded-md py-1 px-2 mb-1.5 mr-5"
          v-model="challengeData"
        >
          <option value="pseudo">Pseudo</option>
          <option value="walletAddress">Wallet Address</option>
          <option value="publicKey">Public Key</option>
          <option value="did">DID</option>
          <option value="authenticationKey">Authentication Key</option>
          <option value="email">Email</option>
          <option value="telephone">Telephone</option>
          <option value="xUsername">X Username</option>
        </select>
      </div>
      <div v-if="challengeType == 'xPost'" class="flex gap-2">
        <p class="pt-1">Message :</p>
        <input
          class="w-[18rem] border-gray-200 border-[1px] focus:border-gray-300 focus:ring-0 placeholder:text-gray-900 placeholder:text-sm hover:bg-gray-light cursor-pointer rounded-md py-1 px-2 mb-1.5"
          :placeholder="'Enter message'"
          maxlength="100"
          v-model="challengeData"
        />
      </div>
      <div v-if="challengeType == 'xFollow'" class="flex gap-2">
        <p class="pt-1">Targeted X Account :</p>
        <input
          class="w-[18rem] border-gray-200 border-[1px] focus:border-gray-300 focus:ring-0 placeholder:text-gray-900 placeholder:text-sm hover:bg-gray-light cursor-pointer rounded-md py-1 px-2 mb-1.5"
          :placeholder="'Enter X Account'"
          maxlength="100"
          v-model="challengeData"
        />
      </div>
      <div v-if="challengeType == 'xRepost'" class="flex gap-2">
        <p class="pt-1">Tweet ID :</p>
        <input
          class="w-[18rem] border-gray-200 border-[1px] focus:border-gray-300 focus:ring-0 placeholder:text-gray-900 placeholder:text-sm hover:bg-gray-light cursor-pointer rounded-md py-1 px-2 mb-1.5"
          :placeholder="'Enter tweet ID'"
          maxlength="100"
          v-model="challengeData"
        />
      </div>
      <div v-if="challengeType == 'discordJoin'" class="flex gap-2">
        <p class="pt-1">Discord Invite Link :</p>
        <input
          class="w-[18rem] border-gray-200 border-[1px] focus:border-gray-300 focus:ring-0 placeholder:text-gray-900 placeholder:text-sm hover:bg-gray-light cursor-pointer rounded-md py-1 px-2 mb-1.5"
          :placeholder="'Enter discord invite link'"
          maxlength="100"
          v-model="challengeData"
        />
      </div>
      <div v-if="challengeType == 'facebookFollow'" class="flex gap-2">
        <p class="pt-1">Facebook Page ID :</p>
        <input class="w-[18rem] border-gray-200 border-[1px]
        focus:border-gray-300 focus:ring-0 placeholder:text-gray-900
        placeholder:text-sm hover:bg-gray-light cursor-pointer rounded-md py-1
        px-2 mb-1.5" :placeholder="'Enter facebook page ID'"
        v-model="challengeData"
      </div>
      <div v-if="challengeType == 'facebookFollow'" class="flex gap-2">
        <p class="pt-1">Facebook Page Link :</p>
        <input
          class="w-[18rem] border-gray-200 border-[1px] focus:border-gray-300 focus:ring-0 placeholder:text-gray-900 placeholder:text-sm hover:bg-gray-light cursor-pointer rounded-md py-1 px-2 mb-1.5"
          :placeholder="'Enter facebook page link'"
          v-model="challengePageLink"
        />
      </div>
      <div v-if="challengeType == 'facebookPost'" class="flex gap-2">
        <p class="pt-1">Facebook Post Message :</p>
        <input class="w-[18rem] border-gray-200 border-[1px]
        focus:border-gray-300 focus:ring-0 placeholder:text-gray-900
        placeholder:text-sm hover:bg-gray-light cursor-pointer rounded-md py-1
        px-2 mb-1.5" :placeholder="'Enter facebook post message'"
        v-model="challengeData"
      </div>
      <div
        v-if="challengeType == 'sentBadges' || challengeType == 'ownsBadges'"
        class="flex gap-2"
      >
        <p class="pt-1">Badge Template hash List :</p>
        <input
          class="w-[18rem] border-gray-200 border-[1px] focus:border-gray-300 focus:ring-0 placeholder:text-gray-900 placeholder:text-sm hover:bg-gray-light cursor-pointer rounded-md py-1 px-2 mb-1.5"
          :placeholder="'Enter badge template hash list (separated by commas)'"
          v-model="challengeData"
        />
      </div>
      <div v-if="challengeType == 'ownsBadges'" class="flex gap-2">
        <p class="pt-1">Badge Count :</p>
        <input
          class="w-[18rem] border-gray-200 border-[1px] focus:border-gray-300 focus:ring-0 placeholder:text-gray-900 placeholder:text-sm hover:bg-gray-light cursor-pointer rounded-md py-1 px-2 mb-1.5"
          :placeholder="'Enter badge count'"
          v-model="challengeBadgeCount"
        />
      </div>

      <div v-if="challengeType == 'telegramJoin'" class="flex gap-2">
        <p class="pt-1">Telegram Target Account :</p>
        <input
          class="w-[18rem] border-gray-200 border-[1px] focus:border-gray-300 focus:ring-0 placeholder:text-gray-900 placeholder:text-sm hover:bg-gray-light cursor-pointer rounded-md py-1 px-2 mb-1.5"
          :placeholder="'Enter telegram target account'"
          v-model="challengeData"
        />
      </div>
      <div class="flex gap-2">
        <p class="pt-1">Reward :</p>
        <input
          class="w-[18rem] border-gray-200 border-[1px] focus:border-gray-300 focus:ring-0 placeholder:text-gray-900 placeholder:text-sm hover:bg-gray-light cursor-pointer rounded-md py-1 px-2 mb-1.5"
          :placeholder="'Points amount'"
          v-model="challengeReward"
        />
      </div>
    </div>

    <!-- div for badge preview -->
    <div
      v-if="challengeType == 'ownsBadges' || challengeType == 'sentBadges'"
      class="flex flex-wrap gap-5 my-10"
    >
      <div
        v-if="!templateListLoading"
        v-for="(template, index) in templateList.filter(
          (template) => template.contractState == 'stored'
        )"
        :key="template.hash"
      >
        <input
          type="checkbox"
          :checked="challengeData.includes(template.hash)"
          @click.stop
          @change="selectBadgeTemplate(template, $event.target.checked)"
        />
        <TemplatePreview
          v-if="template.data && currentIssuerInfo"
          :templateImage="template.data.image"
          :templateName="template.data.name"
          :templateLocation="
            ['Participation', 'Ticket'].includes(challengeData)
              ? template.data.eventDetails.location.split(', ')[0]
                ? template.data.eventDetails.location.split(', ')[0]
                : $t('templateDisplay.virtualTxt')
              : null
          "
          :templateStartDate="
            ['Participation', 'Ticket'].includes(challengeData)
              ? template.data.eventDetails.startDate
              : null
          "
          :templateEndDate="
            ['Participation', 'Ticket'].includes(challengeData)
              ? template.data.eventDetails.endDate
              : null
          "
          :templateThemeBgColor="
            template.data.badgeTheme
              ? template.data.badgeTheme.backgroundCardColor
              : null
          "
          :templateThemeTextColor="
            template.data.badgeTheme ? template.data.badgeTheme.textColor : null
          "
          :templateThemeEffect="
            template.data.badgeTheme
              ? template.data.badgeTheme.cardEffect
              : null
          "
          :templateThemeTexture="
            template.data.badgeTheme
              ? template.data.badgeTheme.textureImageURL
              : null
          "
          :templateThemeIsLogoBack="
            template.data.badgeTheme
              ? template.data.badgeTheme.isLogoBack
              : null
          "
          :templateThemeShape="
            template.data.badgeTheme ? template.data.badgeTheme.shape : null
          "
          :templateSessions="template.sessions"
          :issuerName="currentIssuerInfo.name"
          :issuerImage="currentIssuerInfo.profileImage"
          :templateContractState="template.contractState"
          :type="challengeType == 'sentBadges' ? 'Community' : 'Basic'"
          class="cursor-pointer"
        />
      </div>
      <div v-if="templateListLoading" class="w-full flex justify-center pt-10">
        <Vue3Lottie
          :animationLink="require('/assets/images/loader-round.jpg')"
          :height="100"
          :width="100"
          :speed="1.5"
        />
      </div>
    </div>
    <button
      class="text-md bg-secondary text-white shadow-sm font-medium rounded-lg cursor-pointer py-1.5 px-2"
      @click="createChallenge"
    >
      Create challenge
    </button>
    <p class="text-lg mb-2 mt-16">Quests</p>
    <div class="flex flex-wrap gap-2 mb-5">
      <div
        v-for="quest in quests"
        :key="quest.id"
        class="flex-none w-full relative border border-gray-600 bg-gray-100 rounded-lg p-3"
      >
        <div class="flex">
          <p class="font-bold mr-2">{{ quest.title }}</p>
          <p
            class="text-sm border border-black rounded-md px-1 cursor-pointer"
            @click="fillQuestFields(quest)"
          >
            Edit<icon name="edit-pencil" class="text-xs ml-1 pb-0.5" />
          </p>
        </div>
        <p class="text-sm mb-2">Description : {{ quest.description }}</p>
        <p class="text-xs">Challenges : {{ quest.challenges.join(', ') }}</p>
        <p class="text-xs mb-2">
          Required challenges : {{ quest.requiredChallenges.join(', ') }}
        </p>
        <p class="text-xs">
          Start date :
          {{ quest.startDate.replace('T', ' ').replace('Z', '').split('.')[0] }}
        </p>
        <p class="text-xs mb-2">
          End date :
          {{ quest.endDate.replace('T', ' ').replace('Z', '').split('.')[0] }}
        </p>
        <p class="text-xs">
          Terms URL :
          <a :href="quest.termsUrl" target="_blank">{{ quest.termsUrl }}</a>
        </p>
        <p class="text-xs">Success message : {{ quest.successMessage }}</p>
        <p class="text-xs">
          Limit : {{ quest.limit ? quest.limit : 'No limit' }}
        </p>
        <button
          @click="deleteQuest(quest.id)"
          class="absolute top-0 right-0 p-3 cursor-pointer"
        >
          <icon name="trash" class="text-xs" />
        </button>
      </div>
    </div>
    <p v-if="questId" class="mb-2">
      Editing quest
      <span class="font-bold">{{
        quests.find((quest) => quest.id == questId).title
      }}</span>
    </p>
    <div class="flex gap-2">
      <div class="w-96 mb-3">
        <span class="absolute text-xs font-bold text-gray-400 pt-1.5 pl-3"
          >Title</span
        >
        <input
          type="text"
          :placeholder="'Enter title'"
          class="w-full outline-none border-gray-300 border rounded-lg px-3 pb-2 pt-5"
          v-model="questTitle"
        />
      </div>
      <div class="w-96 mb-3">
        <span class="absolute text-xs font-bold text-gray-400 pt-1.5 pl-3"
          >Description</span
        >
        <input
          type="text"
          :placeholder="'Enter description'"
          class="w-full outline-none border-gray-300 border rounded-lg px-3 pb-2 pt-5"
          v-model="questDescription"
        />
      </div>
    </div>
    <div class="w-[775px] mb-3">
      <span class="absolute text-xs font-bold text-gray-400 pt-1.5 pl-3"
        >Challenges IDs (separated by commas)</span
      >
      <input
        type="text"
        :placeholder="'Enter challenges IDs'"
        class="w-full outline-none border-gray-300 border rounded-lg px-3 pb-2 pt-5"
        v-model="questChallenges"
      />
    </div>
    <div class="w-[775px] mb-3">
      <span class="absolute text-xs font-bold text-gray-400 pt-1.5 pl-3"
        >Required challenges IDs (separated by commas)</span
      >
      <input
        type="text"
        :placeholder="'Enter required challenges IDs'"
        class="w-full outline-none border-gray-300 border rounded-lg px-3 pb-2 pt-5"
        v-model="questRequiredChallenges"
      />
    </div>
    <div class="flex gap-2">
      <div class="w-64 mb-3">
        <span class="absolute text-xs font-bold text-gray-400 pt-1.5 pl-3"
          >Terms URL</span
        >
        <input
          type="text"
          :placeholder="'Enter terms URL'"
          class="w-full outline-none border-gray-300 border rounded-lg px-3 pb-2 pt-5"
          v-model="questTermsURL"
        />
      </div>
      <div class="w-64 mb-3">
        <span class="absolute text-xs font-bold text-gray-400 pt-1.5 pl-3"
          >Success message</span
        >
        <input
          type="text"
          :placeholder="'Enter success message'"
          class="w-full outline-none border-gray-300 border rounded-lg px-3 pb-2 pt-5"
          v-model="questSuccessMessage"
        />
      </div>
      <div class="w-64 mb-3">
        <span class="absolute text-xs font-bold text-gray-400 pt-1.5 pl-3"
          >Limit</span
        >
        <input
          type="number"
          :placeholder="'Enter limit'"
          class="w-full outline-none border-gray-300 border rounded-lg px-3 pb-2 pt-5"
          v-model="questLimit"
        />
      </div>
    </div>
    <div class="flex flex-row items-center">
      <p class="w-32">
        {{ $t('templateCreation.startDateTxt') }}
      </p>
      <div class="relative">
        <p
          @click="showQuestStartDatePicker = !showQuestStartDatePicker"
          class="w-32 h-7 border border-gray-300 outline text-sm outline-0 hover:bg-gray-light cursor-pointer rounded-md pt-0.5 px-1"
          click-outside-ignore-startdatepicker
        >
          {{ questStartDate.toISOString().split('T')[0] }}
        </p>
        <div
          v-if="showQuestStartDatePicker"
          class="absolute w-modal-xs bg-white border shadow-md rounded-md z-10"
        >
          <div
            class="h-fit"
            click-outside-ignore-startdatepicker-target
            v-click-outside="
              () => {
                showQuestStartDatePicker = false;
              }
            "
          >
            <datepicker
              class="bg-gray-200 border-none"
              :inline="true"
              menu-class-name="w-modal-xs"
              v-model="startDatePickerValue"
              :preview-format="formatDateWithLocation"
              @update:model-value="
                () => {
                  questStartDate = startDatePickerValue;
                  showQuestStartDatePicker = false;
                }
              "
            />
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-row items-center">
      <p class="w-32">
        {{ $t('templateCreation.endDateTxt') }}
      </p>
      <div class="relative">
        <p
          @click="showQuestEndDatePicker = !showQuestEndDatePicker"
          class="w-32 h-7 border border-gray-300 outline text-sm outline-0 hover:bg-gray-light cursor-pointer rounded-md pt-0.5 px-1"
          click-outside-ignore-enddatepicker
        >
          {{ questEndDate.toISOString().split('T')[0] }}
        </p>
        <div
          v-if="showQuestEndDatePicker"
          class="absolute w-modal-xs bg-white border shadow-md rounded-md z-10"
        >
          <div
            class="h-fit"
            click-outside-ignore-enddatepicker-target
            v-click-outside="
              () => {
                showQuestEndDatePicker = false;
              }
            "
          >
            <datepicker
              class="bg-gray-200 border-none"
              :inline="true"
              menu-class-name="w-modal-xs"
              v-model="endDatePickerValue"
              :preview-format="formatDateWithLocation"
              @update:model-value="
                () => {
                  questEndDate = endDatePickerValue;
                  showQuestEndDatePicker = false;
                }
              "
            />
          </div>
        </div>
      </div>
    </div>
    <button
      class="text-md bg-secondary text-white shadow-sm font-medium rounded-lg cursor-pointer py-1.5 px-2 mt-5"
      @click="questId ? updateQuest() : createQuest()"
    >
      {{ questId ? 'Update quest' : 'Create quest' }}
    </button>
  </div>
</template>

<script>
import { ref, watch, onMounted, inject, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import TemplatePreview from '../../components/templates/TemplatePreview.vue';
export default {
  components: {
    TemplatePreview,
  },
  setup() {
    const api = inject('api');
    const utils = inject('utils');
    const { t } = useI18n();
    const store = useStore();

    const challenges = ref([]);
    const challengeType = ref('vcAuth');
    const challengeData = ref('');
    const challengeBadgeCount = ref(null);
    const challengePageLink = ref('');
    const challengeReward = ref(null);
    const quests = ref([]);
    const questStartDate = ref(new Date());
    const questEndDate = ref(new Date());
    const showQuestStartDatePicker = ref(false);
    const showQuestEndDatePicker = ref(false);
    const questTitle = ref('');
    const questDescription = ref('');
    const questChallenges = ref('');
    const questRequiredChallenges = ref('');
    const questTermsURL = ref('');
    const questSuccessMessage = ref('');
    const questLimit = ref(null);
    const questId = ref(null);

    const currentIssuerInfo = computed(
      () => store.getters.getCurrentIssuerInfo
    );

    const templateList = computed(() => {
      if (!['sentBadges', 'ownsBadges'].includes(challengeType.value)) return;
      return challengeType.value === 'sentBadges'
        ? store.getters[`getCommunityTemplateList`]
        : store.getters[`getBasicTemplateList`];
    });

    const templateListLoading = computed(
      () => store.getters.getTemplateListLoading
    );

    const computedChallengeData = computed(() => {
      if (challengeType.value == 'vcAuth') {
        return { vcKey: challengeData.value };
      } else if (challengeType.value == 'xAuth') {
        return null;
      } else if (challengeType.value == 'xPost') {
        return { message: challengeData.value };
      } else if (challengeType.value == 'xFollow') {
        return { targetAccount: challengeData.value };
      } else if (challengeType.value == 'xRepost') {
        return { tweetId: challengeData.value };
      } else if (challengeType.value == 'discordAuth') {
        return null;
      } else if (challengeType.value == 'discordJoin') {
        return { inviteLink: challengeData.value };
      } else if (challengeType.value == 'facebookAuth') {
        return null;
      } else if (challengeType.value == 'facebookFollow') {
        return {
          pageId: challengeData.value,
          targetAccount: challengePageLink.value,
        };
      } else if (challengeType.value == 'facebookPost') {
        return { message: challengeData.value };
      } else if (challengeType.value == 'linkedinAuth') {
        return null;
      } else if (challengeType.value == 'telegramAuth') {
        return null;
      } else if (challengeType.value == 'telegramJoin') {
        return { targetAccount: challengeData.value };
      } else if (challengeType.value == 'ownsBadges') {
        return {
          templateHashList: challengeData.value
            .split(',')
            .map((hash) => hash.trim()),
          count: challengeBadgeCount.value,
        };
      } else if (challengeType.value == 'sentBadges') {
        return {
          templateHashList: challengeData.value
            .split(',')
            .map((hash) => hash.trim()),
        };
      }
    });

    function emptyChallengeFields() {
      challengeType.value = 'vcAuth';
      challengeData.value = '';
      challengeReward.value = null;
      challengePageLink.value = '';
      challengeBadgeCount.value = null;
    }

    function emptyQuestFields() {
      questTitle.value = '';
      questDescription.value = '';
      questChallenges.value = '';
      questRequiredChallenges.value = '';
      questTermsURL.value = '';
      questSuccessMessage.value = '';
      questLimit.value = null;
      questId.value = null;
      questStartDate.value = new Date();
      questEndDate.value = new Date();
    }

    function fillQuestFields(quest) {
      questId.value = quest.id;
      questTitle.value = quest.title;
      questDescription.value = quest.description;
      questChallenges.value = quest.challenges.join(',');
      questRequiredChallenges.value = quest.requiredChallenges.join(',');
      questTermsURL.value = quest.termsUrl;
      questSuccessMessage.value = quest.successMessage;
      questLimit.value = quest.limit;
      questStartDate.value = new Date(quest.startDate);
      questEndDate.value = new Date(quest.endDate);
    }

    async function getChallenges() {
      api.getCommunityChallenges().then((response) => {
        challenges.value = response.data;
      });
    }
    getChallenges();

    async function deleteChallenge(challengeId) {
      api.deleteCommunityChallenge(challengeId).then(() => {
        getChallenges();
      });
    }

    async function getQuests() {
      api.getCommunityQuests().then((response) => {
        quests.value = response.data;
      });
    }
    getQuests();

    async function deleteQuest(questId) {
      api.deleteCommunityQuest(questId).then(() => {
        getQuests();
      });
    }

    async function createChallenge() {
      api
        .createCommunityChallenge({
          type: challengeType.value,
          data: computedChallengeData.value,
          reward: challengeReward.value || null,
        })
        .then(() => {
          getChallenges();
          emptyChallengeFields();
        })
        .catch((err) => {
          console.log('err', err);
          if (err.response?.data?.message) {
            utils.showToastMessageError(err.response?.data?.message);
          } else {
            utils.showToastMessageError(t('other.serverError'));
          }
        });
    }

    async function createQuest() {
      api
        .createCommunityQuest({
          title: questTitle.value,
          description: questDescription.value,
          challenges: questChallenges.value.trim().split(','),
          requiredChallenges: questRequiredChallenges.value.trim().split(','),
          startDate: questStartDate.value,
          endDate: questEndDate.value,
          termsUrl: questTermsURL.value,
          successMessage: questSuccessMessage.value,
          limit: questLimit.value,
        })
        .then(() => {
          getQuests();
          emptyQuestFields();
        })
        .catch((err) => {
          console.log('err', err);
          if (err.response?.data?.message) {
            utils.showToastMessageError(err.response?.data?.message);
          } else {
            utils.showToastMessageError(t('other.serverError'));
          }
        });
    }

    async function updateQuest() {
      api
        .updateCommunityQuest(questId.value, {
          title: questTitle.value,
          description: questDescription.value,
          challenges: questChallenges.value.trim().split(','),
          requiredChallenges: questRequiredChallenges.value.trim().split(','),
          startDate: questStartDate.value,
          endDate: questEndDate.value,
          termsUrl: questTermsURL.value,
          successMessage: questSuccessMessage.value,
          limit: questLimit.value,
        })
        .then(() => {
          getQuests();
          emptyQuestFields();
        })
        .catch((err) => {
          console.log('err', err);
          if (err.response?.data?.message) {
            utils.showToastMessageError(err.response?.data?.message);
          } else {
            utils.showToastMessageError(t('other.serverError'));
          }
        });
    }

    async function copyToClipboard(value) {
      console.log('navigator', value);
      await navigator.clipboard.writeText(value);
      utils.showToastMessageSuccess(t('other.clipboardCopyTxt'));
    }

    function selectBadgeTemplate(template, checked) {
      let templateHashArray =
        challengeData.value.length > 0 ? challengeData.value.split(',') : [];
      if (checked) {
        if (templateHashArray.includes(template.hash)) return;
        templateHashArray.push(template.hash);
      } else {
        templateHashArray = templateHashArray.filter(
          (hash) => hash !== template.hash
        );
      }
      challengeData.value = templateHashArray.join(',');
    }

    // when challengeType changes, reset challengeData
    watch(challengeType, () => {
      challengeData.value = '';
    });

    return {
      challenges,
      challengeType,
      challengeData,
      createChallenge,
      createQuest,
      updateQuest,
      quests,
      questStartDate,
      questEndDate,
      questTitle,
      questDescription,
      questChallenges,
      questRequiredChallenges,
      questTermsURL,
      questSuccessMessage,
      questLimit,
      showQuestStartDatePicker,
      showQuestEndDatePicker,
      questId,
      copyToClipboard,
      fillQuestFields,
      challengePageLink,
      challengeBadgeCount,
      currentIssuerInfo,
      templateList,
      templateListLoading,
      selectBadgeTemplate,
      challengeReward,
      deleteChallenge,
      deleteQuest,
    };
  },
};
</script>
